var _circle, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeGlassesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 22.5,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6 29.0003C18.1405 29.0003 20.2 26.911 20.2 24.3337C20.2 21.7563 18.1405 19.667 15.6 19.667C13.0595 19.667 11 21.7563 11 24.3337C11 26.911 13.0595 29.0003 15.6 29.0003Z",
    stroke: "#0066FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3998 29.0003C31.9403 29.0003 33.9998 26.911 33.9998 24.3337C33.9998 21.7563 31.9403 19.667 29.3998 19.667C26.8593 19.667 24.7998 21.7563 24.7998 24.3337C24.7998 26.911 26.8593 29.0003 29.3998 29.0003Z",
    stroke: "#0066FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.2 24.3333L20.4427 24.2097C21.0814 23.8856 21.7858 23.7169 22.5 23.7169C23.2142 23.7169 23.9186 23.8856 24.5573 24.2097L24.8 24.3333M30.55 15L33.8137 22.7268C33.9365 23.0173 33.9999 23.3301 34 23.6462V24.3333M14.45 15L11.1863 22.7268C11.0636 23.017 11.0002 23.3293 11 23.645V24.3333",
    stroke: "#0066FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeGlassesIcon);
export default __webpack_public_path__ + "static/media/eyeGlassesIcon.720d848b4cb3d80b0d308c74093091e2.svg";
export { ForwardRef as ReactComponent };